import React, {Component} from 'react'
import {components} from 'react-select'
import propTypes from 'prop-types'
import Icon from 'components/icon'

class Option extends Component {

  getColour = () => {
    const {data} = this.props
    return data.colour && (
      <div
        className={'selectField-colour'}
        style={{backgroundColor: data.colour}}
      />
    )
  }

  getIcon = () => {
    const {data} = this.props
    return data.icon && (
      <Icon
        name={data.icon}
        color={data.iconColour}
        size={data.iconSize || 18}
      />
    )
  }

  render() {
    const {data, children, ...otherProps} = this.props

    const className = data.className
      ? `selectField-option ${data.className}`
      : 'selectField-option'

    return (
      <components.Option {...otherProps}>
        <div className={className} title={data.title}>
          {this.getColour()}
          {this.getIcon()}
          {children}
        </div>
      </components.Option>
    )
  }
}

Option.propTypes = {
  children: propTypes.node,
  data: propTypes.shape({
    colour: propTypes.string,
    title: propTypes.string,
    icon: propTypes.string,
    iconSize: propTypes.number,
    iconColour: propTypes.string,
    className: propTypes.string,
  }).isRequired,
}

export default Option
